module.exports = __webpack_public_path__ + "static/media/screen-nemox.a95d73de.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/WorksSection/screens/screen-nemox.png
// module id = 326
// module chunks = 0